import * as React from "react";
import AppTableInvoices from "../tables/AppTableInvoices";
import { CircularProgress, Alert, Box, Pagination, Stack } from "@mui/material";
import { InvoiceType, StatusType } from "../../types/entitiesModel";
import { AuthContext } from "../../context/AuthContext";


function InvoicesView() {
  const { token } = React.useContext(AuthContext) || {};
  const [invoices, setInvoices] = React.useState<InvoiceType[]>([]);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(true);

  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
  });

  const [selectedStatus, setSelectedStatus] = React.useState<StatusType>({
    id: "",
    description: "",
  });

  const fetchInvoices = async (
    page: number,
    perPage: number,
    status: string
  ) => {
    setLoading(true);
    try {
      let options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetch(
        `/api/invoices?page=${page}&per_page=${perPage}&status=${status}`,
        options
      );
      const data = await response.json();

      if (response.ok) {
        setInvoices(data.data);
        setPagination((prev) => ({
          ...prev,
          totalPages: data.pagination.total_pages,
        }));
        setError(null);
      } else {
        setError("Error obteniendo facturas");
      }
    } catch (err) {
      setError("Error obteniendo facturas");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };

  React.useEffect(() => {
    fetchInvoices(
      pagination.currentPage,
      pagination.perPage,
      selectedStatus.id
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, pagination.perPage, selectedStatus.id, token]);

  return (
    <>
      {!loading ? (
        <>
          {error && (
            <Alert
              sx={{
                mx: "auto",
                my: 2,
                width: "95%",
              }}
              severity="error"
            >
              {error}
            </Alert>
          )}

          <Box>
            <AppTableInvoices
              data={invoices}
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
            />
            <Stack spacing={2} alignItems="center" sx={{ marginTop: 2 }}>
              <Pagination
                count={pagination.totalPages}
                page={pagination.currentPage}
                onChange={handlePageChange}
                color="primary"
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </Box>
        </>
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
}

export default InvoicesView;
